module.exports = new __parcel__URL__("8071_h.bed4a319.jpg").toString();